import React, { useReducer } from "react";
import { reducer, initialState } from "./reducer";
import OffersContext from "./offersContext";

const OffersProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <OffersContext.Provider value={{ state, dispatch }}>{children}</OffersContext.Provider>;
};


export default OffersProvider;
